import { createContext, PropsWithChildren, useMemo, useState } from 'react';
import { User } from './types/models';
import { LangEnum, UserRole } from './utils/constants';

type AppData = {
  userMeta: User;
  setUserMeta: (user: User) => void;
};

const initialUserData: User = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  organizationId: '',
  organizationName: '',
  systemRole: UserRole.USER,
  organizations: [],
  defaultTranslationLanguage: LangEnum.en,
  systemLanguage: LangEnum.en,
};

// eslint-disable-next-line react-refresh/only-export-components
export const AppContext = createContext<AppData>({
  userMeta: initialUserData,
  setUserMeta: () => null,
});

export default function AppProvider({ children }: PropsWithChildren) {
  const [userMeta, setUserMeta] = useState<User>(initialUserData);

  const ctxValue = useMemo(
    () => ({
      userMeta,
      setUserMeta,
    }),
    [userMeta],
  );

  return <AppContext.Provider value={ctxValue}>{children}</AppContext.Provider>;
}
